<h2>Certificates</h2>
<div class="mat-elevation-z8">
    <div class="table-responsive text-center justify-content-center" style="
      font-size: 14px;
      margin-bottom: 20px;
      text-align: center;
      vertical-align: center;
    ">
        <p-table #dt1 dataKey="id" [value]="pending_certificates" [rows]="10" [paginator]="true"
            [showCurrentPageReport]="true" [scrollable]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['name', 'expiryDate']">
            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="50" placeholder="Search"
                            (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            style="width: 250px; margin-left: 75%" />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                   
                    <th pSortableColumn="doctor_name">
                        <b>Doctor Name</b><p-sortIcon field="name"></p-sortIcon>
                    </th>

                    <th pSortableColumn="d_email" style="width: 400px;">
                        <b>Doctor Email</b><p-sortIcon field="name"></p-sortIcon>
                    </th>

                    <th pSortableColumn="cert_name">
                        <b>Certificate Name</b><p-sortIcon field="name"></p-sortIcon>
                    </th>

                    <th pSortableColumn="expires_on">
                        <b>Expiry Date</b><p-sortIcon field="email"></p-sortIcon>
                    </th>
                    <th pSortableColumn="file">
                        <b>File</b><p-sortIcon field="approve"></p-sortIcon>
                    </th>
                    <th pSortableColumn="approve">
                        <b>Approve</b><p-sortIcon field="contact_name"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-certificate>
                <tr>
                    <td>{{certificate.doctor_name}} </td>
                    <td style="width: 400px;">{{certificate.d_email}}</td>
                    <td>{{certificate.document_name}} </td>
                    <td>{{certificate.expires_on | date: 'medium'}} </td>
                    <td> <p-button label="Download Certificate"
                            (click)="DownloadCertificate(certificate.id,certificate.doctor_user_guid)"></p-button></td>

                    <td>
                        <div>
                            <p-button label="Approve" (click)="ApproveCerificate(certificate.id)"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>